import { computed, defineComponent, onBeforeMount, ref, watch } from '@vue/composition-api';
import { getQuery } from '@/utils/url';
import { creatorStorage } from '@/utils/storage';
import { logger } from '@/utils/logger';
import MyButton from '../sub-components/my-button.vue';
import { toPost } from '@/utils/ikwai';
import { sendTop100CustomLog } from '@/utils/custom-log';
import MyBox from '../sub-components/box.vue';
import DrawVideo from '../sub-components/draw-video.vue';
export default defineComponent({
  components: {
    MyButton: MyButton,
    MyBox: MyBox,
    DrawVideo: DrawVideo
  },
  setup: function setup(props, ctx) {
    //  不可抽奖(点击去拍摄)、可抽奖、已抽奖
    var drawType = ref('need-post'); // 是否可抽奖

    var canDrawQuery = getQuery('canDraw'); // 变成可抽奖

    var changeToCanDraw = function changeToCanDraw() {
      if (drawType.value === 'done') {
        return;
      }

      drawType.value = 'enable';
    };

    var handleCanDrawQuery = function handleCanDrawQuery() {
      if (canDrawQuery) {
        changeToCanDraw();
      }
    }; // 保存信息


    var saveDrawType = function saveDrawType() {
      creatorStorage.set('top100_draw', drawType.value);
    };

    var drawPlay = ref(false); // 参与抽奖,并且变成已抽奖

    var toDraw = function toDraw() {
      drawType.value = 'done';
      drawPlay.value = true;
    };

    var loggerMap = {
      done: '',
      enable: 'MF_LOTTERY_BUTTON',
      'need-post': 'MF_FILM_BUTTON'
    }; // 记录抽奖，其实上报埋点

    var saveDraw = function saveDraw() {
      sendTop100CustomLog({
        event: 'clickToDraw'
      });
    };

    var initDrawType = function initDrawType() {
      var storageDrawType = creatorStorage.get('top100_draw');

      if (storageDrawType) {
        drawType.value = storageDrawType;
      }

      watch(function () {
        return drawType.value;
      }, function (newVal, oldVal) {
        // 进行报名
        if (newVal === 'done' && oldVal === 'enable') {
          saveDraw();
        }

        saveDrawType();
      });
      handleCanDrawQuery();
      watch(function () {
        return drawType.value;
      }, function () {
        if (loggerMap[drawType.value]) {
          logger.kwailog.sendShow({
            action: loggerMap[drawType.value]
          });
        }
      }, {
        immediate: true
      });
    };

    onBeforeMount(function () {
      initDrawType();
    });
    var buttonTextMap = {
      enable: 'Participe do Sorteio',
      'need-post': 'Grave Agora',
      done: 'Participado, aguarde o resultado'
    };
    var buttonText = computed(function () {
      return buttonTextMap[drawType.value];
    });

    var handleClick = function handleClick() {
      if (loggerMap[drawType.value]) {
        logger.kwailog.sendClick({
          action: loggerMap[drawType.value]
        });
      } // 还不能抽奖，点击拍摄


      if (drawType.value === 'need-post') {
        // listenPost();
        toPost({
          enter_source: 'TOP100_luckydraw',
          magicFaceId: 524126
        });
        sendTop100CustomLog({
          event: 'clickToPost'
        }); // 可抽奖
      } else if (drawType.value === 'enable') {
        toDraw();
      }
    };

    return {
      toDraw: toDraw,
      buttonText: buttonText,
      handleClick: handleClick,
      drawPlay: drawPlay,
      drawType: drawType
    };
  }
});